// src/pages/support/TributeAndMemorialGifts.js
import React from "react";
import { Helmet } from "react-helmet";
import dummyImage from "../../assets/images/support/tribute.webp";
import CTASection from "../../components/CTASection"; // Add CTASection import
import styled from "styled-components"; // Add styled-components
import SupportOpportunity from "../../components/SupportOpportunity";

const TributeAndMemorialGifts = () => {
  const description = `
    Honor a loved one with a tribute or memorial gift to Habitat for Humanity Buffalo. Your gift will help build homes and communities in their name, creating a lasting legacy.
  `;

  const waysToSupport = [
    "Make a donation in honor of a loved one",
    "Create a memorial fund",
    "Include a tribute in your estate plans",
  ];

  return (
    <>
      <Helmet>
        <title>Tribute and Memorial Gifts - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Honor a loved one with a tribute or memorial gift. Support Habitat Buffalo and create a lasting legacy in their name."
        />
      </Helmet>
      <Container>
        <SupportOpportunity
          title="Tribute and Memorial Gifts"
          image={dummyImage}
          description={description}
          waysToSupport={waysToSupport}
        />
        {/* Add CTA Section */}
        <CTASection
          title="Start Your Tribute or Memorial Gift"
          description="Ready to honor a loved one? Click the button below to get started with your tribute or memorial gift."
          buttonText="Get Started"
          buttonLink="/form/giving"
        />
      </Container>
    </>
  );
};

// Add necessary styled components
const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

export default TributeAndMemorialGifts;
